module.exports = __webpack_public_path__ + "img/home-line4-img2.330034f6.png";